import React from 'react';
import './login.css';
import BETO from '../../img/beto.jpg';
import LOGO from '../../img/foco90.svg';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';

const URL_LOGIN = WS.login;

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE]
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const usuario = this.state.usuario;//'jhonnatansr';//
    const senha = this.state.senha;//'Hopesfall250386';//
    const data = {usuario: usuario, senha: senha};

    var self = this;
    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar,
      usuarioSenha,
      erroLogar
    }
    = this.state.strings;

    if(!usuario && !senha){
      var msg = {
        title: atencao,
        text: usuarioSenha
      };

      Dialog.create(msg);
      return false;
    }else{

      Requisitions({
        url:URL_LOGIN,
        data: data,
        sucess:function(data){
          if(data.status){
            window.localStorage.setItem('loginData', JSON.stringify(data));
            self.props.history.push('/area-restrita/dashboard/');
          }else{
            var msg = {
              title: atencao,
              text: data.msg
            };
            Dialog.create(msg);
          }

        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroLogar
          });
        }
      });
    }
  }

  render() {
    return (
      <div className="page-login" >
        <div className="wrapper-login">
          <div className="pure-g">
              <div className="pure-u-md-3-5 pure-u-1">
                <div className="box-login">
                  <div className="box-login--inner">
                    <div className="box-login-logo"><img src={LOGO} /></div>
                    <p className="txt-sistema-administrativo">Sistema administrativo</p>
                    <form className="form-login"  onSubmit={this.handleSubmit}>
                      <TextInput onChange={this.handleInputChange} name="usuario" title="Usuário" placeholder="Digite o usuário"></TextInput>
                      <TextInput onChange={this.handleInputChange} name="senha" type="password" title="Senha" placeholder="Digite a senha"></TextInput>
                      <div className="box-center-button"><Button type="submit" text="Entrar" classes="button-login simple-button" /></div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="pure-u-2-5 box-login-img-beto">
                <img className="img-beto" src={BETO} />
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/classes/login/Login.js